import actions from './actions'
import mutations from './mutations'

const state = function () {
  return {
    selectedPermissions: {},
    selectedCategories: {},
    rootCategory: {},
    appPermissions: [],
    categories: [],
    roles: [],
    users: [],
    showDeleteUserModal: false,
  }
}

const getters = {
  allselectedPermissions(state) {
    let perms = []
    Object.keys(state.selectedPermissions).forEach(e => perms.push.apply(perms, state.selectedPermissions[e]))
    return perms
  },
  appPermissions(state) {
    return state.appPermissions
  },
}

const module = {
  state,
  getters,
  actions,
  mutations,
}

export default module



// WEBPACK FOOTER //
// ./src/app/appLogic/permissions/store/index.js